import React from "react";
import { useTranslation } from "react-i18next";

export default function ModalMontoQueDebioSerPagadoAConductor({ isOpen, onClose, data = [] }) {
    const { t } = useTranslation();

    const obtenerTotalMonto = (data) => {
        try {
            // console.log('obtenerTotalMonto MontoDetalleModal', data);
            // let total = 0;
            let monto = 0;
            if (Array.isArray(data.detallePedidosFinalizados)) {
                for (let i = 0; i < data.detallePedidosFinalizados.length; i++) {
                    const detallePedido = data.detallePedidosFinalizados[i];
                    if (Array.isArray(detallePedido.productos)) {
                        for (let j = 0; j < detallePedido.productos.length; j++) {
                            const producto = detallePedido.productos[j];
                            monto += Number(producto?.monto);
                        }
                    }
                }
            }
            monto = monto.toFixed(2);
            return monto;
        } catch (err) {
            console.log('obtenerTotalMonto err');
            console.log(err);
            return null;
        }
    };

    const totalMonto = obtenerTotalMonto(data);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* <div className="bg-white rounded-lg  max-h-[500px] overflow-y-auto"> */}
            {/* Background overlay */}
            <div
                className="absolute inset-0 bg-black bg-opacity-40"
                onClick={onClose}
            />

            {/* Modal content */}
            <div className="relative bg-white rounded-lg shadow-lg w-[400px] max-w-[90%] p-6 max-h-[500px] overflow-y-auto">
                <h2 className="text-lg font-semibold mb-4">
                    {t("label_detalle_monto_que_debio_ser_pagado_a_conductor")}
                </h2>

                <div className="space-y-3">
                    {data.detallePedidosFinalizados.length === 0 ? (
                        <p className="text-gray-500 text-sm">
                            {t("label_no_hay_informacion_disponible")}
                        </p>
                    ) : (
                        data.detallePedidosFinalizados.map((item, index) => (
                            <div
                                key={index}
                                className="flex justify-between border-b pb-2"
                            >
                                <div className="flex flex-col">
                                    <span className="text-gray-700">
                                        {item.nombreCliente}
                                    </span>
                                    <span className="text-gray-500 text-sm">
                                        {item.numeroDocumento}
                                    </span>
                                </div>

                                <div className="flex flex-col gap-1">
                                    {item.productos?.map((pago, index) => (
                                        <div key={index} className="flex justify-between items-center text-sm gap-[10px]">
                                            <span className="text-gray-500 text-sm">
                                                {pago.nombreProducto}
                                            </span>

                                            <span className="font-medium">
                                                {Number(pago.monto)}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        ))
                    )}
                </div>

                {/* Total */}
                {data.estadoPagoInfo.length > 0 && (
                    <div className="flex justify-between mt-4 pt-3 border-t font-semibold">
                        <span>{t("label_total")}</span>
                        <span>{totalMonto}</span>
                    </div>
                )}

                {/* Close button */}
                <div className="flex justify-end mt-6">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
                    >
                        {t("label_cerrar")}
                    </button>
                </div>
            </div>
            {/* </div> */}
        </div>
    );
}
